// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module__footer___1aVD9","centered":"Footer-module__centered___2ScNf","textRightTablet":"Footer-module__textRightTablet___esPsK"};